import { HelpCircleIcon } from '@hugeicons/react'

interface GuidanceDoorProps {
  label: string
  onClick: () => void
}

/**
 * A porta que abre a explicação de como preencher o bloco.
 *
 * Rodapé, e não linha no topo do corpo: no topo ela empurrava o conteúdo para
 * baixo e lia como aviso. Aqui é afordância de ajuda — ícone de interrogação,
 * borda superior separando do conteúdo, largura total.
 *
 * O idioma é o do CTA de rodapé do `ObjectivesCard`, que já era a referência
 * aprovada do projeto para "ação que fecha um card": borda superior, `py-3`
 * sobre `text-2xs`, cor de marca. O `py-3` também resolve o alvo de toque com
 * folga (`ACCESSIBILITY.md` §3).
 *
 * Um componente só para os três blocos: o requisito de aparência única vale
 * para a porta tanto quanto para o estado vazio, e três call-sites copiando a
 * mesma classe divergiriam no primeiro ajuste.
 */
export const GuidanceDoor = ({ label, onClick }: GuidanceDoorProps) => (
  <button
    type="button"
    onClick={onClick}
    className="flex w-full cursor-pointer items-center justify-center gap-1 border-0 border-t border-solid border-gray-100 bg-transparent py-3 text-2xs font-bold text-[var(--color-brand)] transition-colors hover:bg-gray-50"
  >
    <HelpCircleIcon size={13} aria-hidden />
    {label}
  </button>
)
